import React from 'react';
import useStyles from './RangeBarStyle';
import { fractionToPercent, formatNumber } from 'helpers/helpers';

interface Props {
  className?: string;
  currentValue: number;
  min: number;
  max: number;
  percentage?: boolean;
  style?: React.CSSProperties;
}

const RangedBar = (props: Props) => {
  const classes = useStyles();
  const { min, max, percentage, currentValue, className, style } = props;
  const pos = Math.min(Math.max(((currentValue - min) / ((max - min) || currentValue)) * 100, 0), 100);

  return (
    <div className={`${classes.root} ${className || ''}`} style={style}>
      <div className={'min'}>{percentage ? fractionToPercent(min, min === 0 ? 0 : undefined) : min}</div>
      <div className={`line`}>
        <div className="bar bgrDark">&nbsp;</div>
        <div className={`indicator`} style={{ left: `${pos}%` }}>
          &nbsp;
        </div>
      </div>
      <div className={'max'}>{percentage ? fractionToPercent(max) : max}</div>
      <div className={'numbers'}>
        <div className={'current'} style={{ left: `${pos}%` }}>
          {percentage ? fractionToPercent(currentValue,2) : formatNumber(currentValue, 2)}
        </div>
      </div>
    </div>
  );
};

export default RangedBar;
